import { clsx } from 'clsx'

import { Post } from '@tribeplatform/gql-client/types'
import { LikeAction } from '@tribeplatform/react-components/Post/Actions'

import type { StaticField } from '../../Views/types.js'

interface Props {
  post: Post
  highlighted: boolean
  stretchX: string
  buttonVariant: StaticField['settings']['buttonVariant']
}
export const ReactButton = ({
  post,
  highlighted,
  stretchX,
  buttonVariant,
}: Props) => {
  return (
    <div
      className={clsx(
        'flex space-s-2 text-content-subdued items-center',
        highlighted && 'ring-2 rounded-sm ring-offset-surface ring-focused',
        stretchX,
      )}
      onClick={e => e.stopPropagation()}
    >
      {buttonVariant === 'icon' && <LikeAction post={post} showText={false} />}
      {buttonVariant === 'text' && <LikeAction post={post} showIcon={false} />}
      {buttonVariant === 'iconText' && <LikeAction post={post} />}
    </div>
  )
}
